import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../lifechronicles/LifeChroniclesHome.css';

import {
  faPiggyBank,
  faUserCheck,
  faCalendarDays,
  faCheckCircle,
  faUtensils,
  faCarrot,
  faMobileScreen,
  faCloudMoon,
  faHandHoldingHeart,
  faTree,
  faStar,
  faSeedling,
  faDumbbell,
  faGift,
  faFaceSmile,
  faBreadSlice,
  faBullseye,
  faHandsPraying,
  faHospitalUser,
  faMoneyBillWave,
  faEnvelopeOpenText,
  faExclamationTriangle,
  faPrescriptionBottleMedical,
  faCameraRetro,
  faHourglassEnd,
  faShoppingBasket,
  faFaceGrinHearts,
  faCalendarPlus,
  faDog,
  faCashRegister,
  faRulerCombined,
  faClipboardList,
  faGamepad,
  faTrash,
  faUsers,
  faBookOpen,
  faReceipt,
  faHeartCircleCheck,
  faTasks,
  faBrain,
  faSuitcase,
  faFolderOpen,
  faSyringe,
  faCar,
  faLeaf,
  faListCheck,
} from "@fortawesome/free-solid-svg-icons";

export const categories = [
  { to: "/assets-list", icon: faPiggyBank, label: "Assets", bgColor: "bg-green-600", textColor: "text-white" },
  { to: "/attendance-list", icon: faUserCheck, label: "Attendance", bgColor: "bg-orange-600", textColor: "text-white" },
  { to: "/calendar-list", icon: faCalendarDays, label: "Calendar", bgColor: "bg-indigo-600", textColor: "text-white" },
  { to: "/checklist-list", icon: faCheckCircle, label: "Checklist", bgColor: "bg-teal-600", textColor: "text-white" },
  { to: "/environment-list", icon: faTree, label: "Environment", bgColor: "bg-teal-600", textColor: "text-white" },
  { to: "/expense-list", icon: faStar, label: "Expense", bgColor: "bg-purple-600", textColor: "text-white" },
  { to: "/events-list", icon: faStar, label: "Events", bgColor: "bg-purple-600", textColor: "text-white" },
  { to: "/experience-list", icon: faSeedling, label: "Experience", bgColor: "bg-indigo-700", textColor: "text-white" },
  { to: "/gift-list", icon: faGift, label: "Gifts", bgColor: "bg-red-500", textColor: "text-white" },
  { to: "/goal-list", icon: faBullseye, label: "Goals", bgColor: "bg-teal-700", textColor: "text-white" },
  { to: "/income-list", icon: faEnvelopeOpenText, label: "Income", bgColor: "bg-purple-700", textColor: "text-white" },
  { to: "/investments-list", icon: faMoneyBillWave, label: "Investments", bgColor: "bg-green-700", textColor: "text-white" },
  { to: "/invitations-list", icon: faEnvelopeOpenText, label: "Invitations", bgColor: "bg-purple-700", textColor: "text-white" },
  { to: "/issues-list", icon: faExclamationTriangle, label: "Issues", bgColor: "bg-red-700", textColor: "text-white" },
  { to: "/loans-list", icon: faMoneyBillWave, label: "Loans", bgColor: "bg-blue-600", textColor: "text-white" },
  { to: "/missed-opportunities-list", icon: faHourglassEnd, label: "Missed-opportunities", bgColor: "bg-red-800", textColor: "text-white" },
  { to: "/monthly-essentials-plan-list", icon: faShoppingBasket, label: "Monthly-essentials-plan", bgColor: "bg-yellow-700", textColor: "text-white" },
  { to: "/routine-others-list", icon: faCalendarPlus, label: "Routine-Others", bgColor: "bg-pink-500", textColor: "text-white" },
  { to: "/petty-account-list", icon: faCashRegister, label: "Petty-Account", bgColor: "bg-yellow-600", textColor: "text-white" },
  { to: "/socialactivity-list", icon: faUsers, label: "Social-Activity", bgColor: "bg-indigo-800", textColor: "text-white" },
  { to: "/study-list", icon: faBookOpen, label: "Study", bgColor: "bg-indigo-800", textColor: "text-white" },
  { to: "/subscription-list", icon: faReceipt, label: "Subscriptions", bgColor: "bg-teal-800", textColor: "text-white" },
  { to: "/tasks-list", icon: faTasks, label: "Task", bgColor: "bg-gray-700", textColor: "text-white" },
  { to: "/thoughts-list", icon: faBrain, label: "Thoughts", bgColor: "bg-blue-800", textColor: "text-white" },
  { to: "/todo-list", icon: faListCheck, label: "ToDo", bgColor: "bg-purple-500", textColor: "text-white" },
  { to: "/travels-list", icon: faSuitcase, label: "Travels", bgColor: "bg-yellow-800", textColor: "text-white" },
  { to: "/unspecified-list", icon: faFolderOpen, label: "Unspecified", bgColor: "bg-red-800", textColor: "text-white" },
  { to: "/visits-list", icon: faCar, label: "Visit", bgColor: "bg-red-900", textColor: "text-white" },
  { to: "/waste-list", icon: faTrash, label: "Waste", bgColor: "bg-gray-900", textColor: "text-white" },
];

//   { to: "/myroutines-diet", icon: faCarrot, label: "Diet Routine", bgColor: "bg-orange-500", textColor: "text-white" },
//   { to: "/exercise-list", icon: faDumbbell, label: "Gym/Yoga/Exercise", bgColor: "bg-red-600", textColor: "text-white" },
//   { to: "/illness-list", icon: faHospitalUser, label: "Illness", bgColor: "bg-teal-800", textColor: "text-white" },
//   { to: "/medicine-list", icon: faPrescriptionBottleMedical, label: "Medicine", bgColor: "bg-teal-800", textColor: "text-white" },
//   { to: "/meditation-list", icon: faLeaf, label: "Meditations", bgColor: "bg-indigo-800", textColor: "text-white" },
//   { to: "/memories-list", icon: faCameraRetro, label: "Memories", bgColor: "bg-purple-900", textColor: "text-white" },
//   { to: "/pet-list", icon: faDog, label: "Pet", bgColor: "bg-teal-600", textColor: "text-white" },
//   { to: "/physical-growth-list", icon: faRulerCombined, label: "Physical Growth", bgColor: "bg-green-800", textColor: "text-white" },
//   { to: "/vaccination-list", icon: faSyringe, label: "Vaccinations", bgColor: "bg-teal-600", textColor: "text-white" },


// { to: "/myroutines-study", icon: faBookOpen, label: "Study Routine", bgColor: "bg-blue-500", textColor: "text-white" },
// { to: "/donation-list", icon: faHandHoldingHeart, label: "Donations", bgColor: "bg-yellow-600", textColor: "text-white" },
// { to: "/bequests-list", icon: faHeartSolid, label: "Bequests", bgColor: "bg-pink-600", textColor: "text-white" },
// { to: "/essentials-list", icon: faClipboardList, label: "Essentials", bgColor: "bg-gray-200", textColor: "text-gray-800" },
// { to: "/storage-list", icon: faFileArchive, label: "Storage", bgColor: "bg-gray-200", textColor: "text-gray-800" },
// { to: "/family-list", icon: faFaceSmile, label: "Family", bgColor: "bg-gray-200", textColor: "text-gray-800" },
// { to: "/friends-list", icon: faUsers, label: "Friends", bgColor: "bg-gray-200", textColor: "text-gray-800" },
// { to: "/favourite-list", icon: faHeartSolid, label: "Favorites", bgColor: "bg-gray-200", textColor: "text-gray-800" }


const MSMEBusinessChroniclesHome = () => {
    const navigate = useNavigate();

    return (
        <div>
            <div className="flex flex-col items-center py-4 px-4 bg-black border border-pink-400 h-auto rounded-lg">
                <p className="text-lg lg:text-xl mb-2 text-yellow-200">Think5Whys Business Chronicles</p>
                <div className='flex flex-col flex-wrap justify-center gap-4 mt-2 text-sm'>
                    <div className="grid grid-cols-3 lg:grid-cols-7 gap-2">
                        {categories.map((category, index) => (
                            <Link 
                                key={index} 
                                to={category.to} 
                                className={`flex flex-col items-center p-6 rounded-lg ${category.bgColor} ${category.textColor} shadow-lg hover:shadow-2xl transition-shadow duration-300`}
                            >
                                <FontAwesomeIcon icon={category.icon} size="x" className="mb-2" />
                                <span className="text-m flex items-center justify-center text-center">{category.label}</span>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
            <footer className="bg-gray-900 border-t border-gray-800 text-gray-400 py-4">
                <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
                    <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions. All rights reserved.</div>
                    <div className="flex flex-wrap gap-4 text-sm">
                    <Link to="/about-us" className="hover:text-teal-300">About</Link>
                    <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
                    <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
                    <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default MSMEBusinessChroniclesHome;
